/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import type { SafeString } from "@ember/template";
import Component from "@glimmer/component";
import type { EmberChangeset } from "ember-changeset";
import type { IntlService } from "ember-intl";

interface Signature {
  Args: {
    changeset: EmberChangeset;
    section: string;
    translationPrefix: string;
  };
}
export default class MiciBaseEditionFormSummaryItemComponent extends Component<Signature> {
  @service declare intl: IntlService;

  get answerPath(): string {
    return `${this.args.translationPrefix}.${this.args.section}.answers`;
  }

  get valueFromChangeset(): string {
    return this.args.changeset.get(this.args.section);
  }

  get answerKey(): string {
    return `${this.answerPath}.${this.valueFromChangeset}`;
  }

  get translation(): string | SafeString {
    if (this.intl.exists(this.answerKey)) {
      return this.intl.t(this.answerKey, { htmlSafe: true });
    }
    return this.intl.t(this.answerPath, {
      value: this.valueFromChangeset,
      htmlSafe: true
    });
  }
}
